export const MainTheme = {
	color: {
		gray100: 'hsl(0, 0%, 96%)',
		gray200: 'hsl(0, 0%, 90%)',
		gray300: 'hsl(0, 0%, 70%)',
		gray350: 'hsl(0, 0%, 65%)',
		gray400: 'hsl(0, 0%, 50%)',
		gray500: 'hsl(0, 0%, 35%)',
		alphaBlack1: 'hsla(0, 0%, 0%, .05)',
		alphaBlack2: 'hsla(0, 0%, 0%, .1)',
		alphaBlack3: 'hsla(0, 0%, 0%, .5)',
		blue: 'hsl(221, 100%, 60%)',
		blueDark: 'hsl(221, 100%, 40%)',
		blueAlpha: 'hsla(221, 100%, 60%, .3)',
		white: '#fff',
		yellow: 'hsl(50, 100%, 70%)',
		red: 'hsl(0, 100%, 70%)',
		green: 'hsl(120, 100%, 70%)',
		purple: 'hsl(290, 80%, 60%)',
		orange: 'hsl(20, 100%, 70%)',
	},
	fontWeight: {
		regular: 300,
		bold: 600,
	},
	fontSize: {
		xxxs: '1rem',
		xxs: '1.2rem',
		xs: '1.4rem',
		s: '1.6rem',
		m: '2.1rem',
		l: '2.4rem',
		xl: '3rem',
		xxl: '4rem',
		xxxl: '8rem',
	},
};
